import { Injectable } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthModel } from '../models/auth.model';
import { UserModel } from '../models/user.model';
import { CryptoExtension } from '../utils/crypto.extension';
import { IAppConfig } from '../models/app-config.model';
import { AppConfig } from '../services/app.config';

const API_LOGIN_URL = `/api/Users/Login`;
const API_LOGIN_SSO_URL = `/api/Users/LoginSSOAuth`;
const API_LOGIN_MOBILE_URL = `/api/Users/LoginMobile`;
const API_USERS = `/api/data/process/GetDataInfo`;
@Injectable({
    providedIn: 'root',
})
export class AuthHTTPService {
    appConfig: IAppConfig
    constructor(
        private http: HttpClient
    ) {
        this.appConfig = AppConfig.getConfig();
    }

    // public methods
    login(user: string, password: string): Observable<any> {
        return this.http.post<AuthModel>(`${this.appConfig.apis.apiUrl}${API_LOGIN_URL}`, {
            user,
            password,
        });
    }
    loginSSO(user: string, token: string): Observable<any> {
        return this.http.post<AuthModel>(`${this.appConfig.apis.apiUrl}${API_LOGIN_SSO_URL}`, {
            user,
            token,
        });
    }
    loginMobile(user: string, employee: string): Observable<any> {
        return this.http.post<AuthModel>(`${this.appConfig.apis.apiUrl}${API_LOGIN_MOBILE_URL}`, {
            user,
            employee,
        });
    }
    // CREATE =>  POST: add a new user to the server
    createUser(user: UserModel): Observable<UserModel> {
        return this.http.post<UserModel>(API_LOGIN_URL, user);
    }

    // Your server should check email => If email exists send link to the user and return true | If email doesn't exist return false
    forgotPassword(email: string): Observable<boolean> {
        return this.http.post<boolean>(`${API_LOGIN_URL}/forgot-password`, {
            email,
        });
    }

    getUserByToken(token: string): Observable<UserModel> {
        const httpHeaders = new HttpHeaders({
            Authorization: `Bearer ${token}`,
        });
        return this.http.get<UserModel>(`${API_LOGIN_URL}/me`, {
            headers: httpHeaders,
        });
    }
    getUserByUserName(userName: string, token: string) {
        let body = {
            "isAction": "0",
            "isNoConfig": "1",
            urctlnk: '/login'
        };
        var res = CryptoExtension.encryptHMAC("GetDataProfileUser", body, userName);
        var _data = {
            "token": '' + res["token"],
            "reqtime": res["reqtime"],
            "data": body,
            "appversion": this.appConfig.appVersion
        };
        let headers = new HttpHeaders()
        headers = headers.set('content-type', 'application/json')
        headers = headers.set('Authorization', "Bearer " + token);
        return this.http.post(`${this.appConfig.apis.apiUrl}/api/data/process/GetDataProfileUser`, _data, { headers });
    }
    getUserMenu(userName: string, token: string) {
        let body = {
            "isAction": "0",
            "isNoConfig": "1",
            urctlnk: '/login'
        };
        var res = CryptoExtension.encryptHMAC("GetDataMenuUser", body, userName);
        var _data = {
            "token": '' + res["token"],
            "reqtime": res["reqtime"],
            "data": body,
            "appversion": this.appConfig.appVersion
        };
        let headers = new HttpHeaders()
        headers = headers.set('content-type', 'application/json')
        headers = headers.set('Authorization', "Bearer " + token);
        return this.http.post(`${this.appConfig.apis.apiUrl}/api/data/process/GetDataMenuUser`, _data, { headers });
    }
    getData(userName: string, token: string, code: string) {
        let body = {
            "isAction": "0",
            "isNoConfig": "1",
            urctlnk: '/login'
        };
        var res = CryptoExtension.encryptHMAC(code, body, userName);
        var _data = {
            "token": '' + res["token"],
            "reqtime": res["reqtime"],
            "data": body,
            "appversion": this.appConfig.appVersion
        };
        let headers = new HttpHeaders()
        headers = headers.set('content-type', 'application/json')
        headers = headers.set('Authorization', "Bearer " + token);
        return this.http.post(`${this.appConfig.apis.apiUrl}/api/data/process/${code}`, _data, { headers });
    }
}
